import { render, staticRenderFns } from "./AdminForm.vue?vue&type=template&id=2283d0f3&scoped=true"
import script from "./AdminForm.vue?vue&type=script&lang=js"
export * from "./AdminForm.vue?vue&type=script&lang=js"
import style0 from "./AdminForm.vue?vue&type=style&index=0&id=2283d0f3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2283d0f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2283d0f3')) {
      api.createRecord('2283d0f3', component.options)
    } else {
      api.reload('2283d0f3', component.options)
    }
    module.hot.accept("./AdminForm.vue?vue&type=template&id=2283d0f3&scoped=true", function () {
      api.rerender('2283d0f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/AdminForm.vue"
export default component.exports